class PauseSubscriptionController {
  static get $inject() {
    return ['$scope', 'subscription', 'nextOrderDate', 'subscriptionOrchestrator', 'toastService', '$state', 'ogDateFilter'];
  }

  constructor($scope, subscription, nextOrderDate, subscriptionOrchestrator, toastService, $state, ogDateFilter) {
    this.$scope = $scope;
    this.subscriptionOrchestrator = subscriptionOrchestrator;
    this.toastService = toastService;
    this.$state = $state;
    this.ogDateFilter = ogDateFilter;

    this.subscription = subscription;
    this.selectedDate = nextOrderDate;

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + 1);

    this.datePickerOptions = {
      minDate: minDate,
      showWeeks: false,
      formatDay: 'd',
      currentMonth: minDate.getMonth(),
      currentYear: minDate.getFullYear()
    };
  }

  submit() {
    this.submitting = this.subscriptionOrchestrator.changeNextOrderDate(this.subscription.publicId, this.selectedDate)
      .then(() => {
        const placeDateStr = this.ogDateFilter(this.selectedDate, 'll');
        this.toastService.translate.success('TOAST_SUBSCRIPTION_PAUSE_SUCCESS', { placeDate: placeDateStr });
      })
      .then(() => this.$scope.$close())
      .then(() => this.$state.go('root', {}, { reload: true }))
      .catch(() => this.toastService.translate.danger('TOAST_SUBSCRIPTION_PAUSE_DANGER'));

    return this.submitting;
  }
}

module.exports = PauseSubscriptionController;
